<template  >
  <NavBar />

  <!-- SHOWCASE SECTION -->
  <section class="bg-gradient-to-r from-[#05224B] to-[#070852] max-h-full relative">
    <!-- section divider -->
    <div class="custom-shape-divider-bottom-1659189854">
      <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none">
        <path
          d="M985.66,92.83C906.67,72,823.78,31,743.84,14.19c-82.26-17.34-168.06-16.33-250.45.39-57.84,11.73-114,31.07-172,41.86A600.21,600.21,0,0,1,0,27.35V120H1200V95.8C1132.19,118.92,1055.71,111.31,985.66,92.83Z"
          class="shape-fill"></path>
      </svg>
    </div>
    <!-- section content -->
    <div class="container mx-auto px-10 md:px-20 py:10 md:py-14">
      <div class="showcase lg:grid md:grid-cols-2 gap-10">
        <div class="text-white">
          <h1 class="pt-10 md:pt-5 mb-10 text-center md:text-left text-2xl  md:text-5xl font-bold tracking-wide"> Improving Education
            through Technology Solutions</h1>

          <p class="mb-10 text-center md:text-left md:text-lg md:pr-5">Providing the best school administration, teaching
            and learning experience to
            educators, students andparents through innovative software and technology.</p>
          <div class="pb-20 md:pb-10">
            <button
              class="flex mx-auto md:mx-0 bg-[#F4A641] text-white text-lg spec-btn md:mb-0 mb-24 px-5 py-2  font-bold  duration-500  hover:bg-cyan-600">Learn
              More</button>
          </div>
        </div>

        <div class="hidden md:block ml-10 mt-20">
          <img class="" src="@/assets/images/edubg.png" alt="">

        </div>
      </div>

    </div>
  </section>

  <!-- PRODUCTS SECTION -->
  <section class="container mx-auto py-20 mt-10">
    <div class=" lg:flex lg:space-x-10 px-10 md:px-20">
      <div class="hidden md:block my-auto slidimg">
        <img class="shadow shadow-slate-400 rounded-md slidimg1 md:mb-5" src="@/assets/images/stat.png" alt="">
      </div>
      <div class="">
        <div class="product1 ">
          <h1 class="text-2xl md:text-3xl font-bold text-[#05224b] leading-snug">
            Our Products Are Designed to Simplify School Activities</h1>
          <p class="leading-7 py-5 text-[#05224b]">FlexiSAF is on a mission to provide the best administration, teaching and learning
            experience to educators,
            parents and students through innovative software and technology.</p>
        </div>
        <div class="md:flex my-5 lg:space-x-10 md:space-x-20 overflow-hidden">
          <div class="bg-[#bfd8f1] px-10 py-3 mb-5 rounded shadow-lg product2">
            <img class="align-middle w-32" src="@/assets/images/safsms.svg" alt="">

          </div>
          <div class="bg-[#c8f7e6] px-10 py-3 rounded shadow-lg product2">
            <img class="align-middle w-32" src="@/assets/images/srms.svg" alt="">

          </div>
        </div>

        <div class="md:flex  lg:space-x-10 md:space-x-20 overflow-hidden">
          <div class="bg-[#d3cafd] px-10 py-3 mb-5 rounded shadow-lg product2">
            <img class="align-middle w-32" src="@/assets/images/safapply.svg" alt="">
          </div>
          <div class="bg-[#a5e5f8] px-10 py-3 mb-5 rounded shadow-lg product2">
            <img class="align-middle w-32" src="@/assets/images/jangu.svg" alt="">
          </div>
        </div>
      </div>

    </div>

  </section>

  <!-- OUR SOLUTIONS SECTION -->
  <section class="bg-[#E3ECF2] md:my-20  text-[#05224b]">
    <div class="container mx-auto py-10 md:py-20 md:pb-56">
      <div class="px-10 md:px-20 overflow-hidden">
        <h1 class="text-center  text-2xl md:text-3xl font-semibold text-[#05224b]"> There is a Solution
          for
          All Stakeholders
        </h1>
        <p class="text-center mt-3 mb-10 md:mb-20 md:text-xl  text-[#05224b]">FlexiSAF Solutions are made for all stakeholders
          of Education in Nigeria.</p>



        <div class="grid grid-row lg:grid-cols-3 gap-10 text-center mb-10">

          <div class="solution1 rounded bg-white py-5 px-5 shadow-2xl shadow-gray-500 hover:shadow-md  text-[#05224b]">
            <img class=" mx-auto w-10" src="@/assets/images/person.svg" alt="">
            <h3 class="text-xl font-medium my-3">School Administrators</h3>
            <p class="text-justify mb-5 text-md">
              We use innovative technology to develop tools for more comprehensive and efficient management of schools
              to
              achieve better results.</p>
          </div>

          <div class="solution1 rounded bg-white py-5 px-5 shadow-2xl shadow-gray-500 hover:shadow-md">
            <img class=" mx-auto w-10" src="@/assets/images/govt.svg" alt="">
            <h3 class="text-xl font-medium my-3">Government Agencies</h3>
            <p class="text-justify mb-5 text-normal ">

              Having deployed several adaptive educational software, our model is strategically aligned to
              aid government agencies in achieving their set educational goals.</p>
          </div>
          <div class="solution1 rounded bg-white py-5 px-5 shadow-2xl shadow-gray-500 hover:shadow-md ">
            <img class=" mx-auto w-10" src="@/assets/images/cap.svg" alt="">
            <h3 class="text-xl font-medium my-3">Educational Bodies</h3>
            <p class="text-justify mb-5 text-md">

              Our solutions allow us to partner with organizations to support learning & teaching, oversight and
              management
              for education in various environments.
            </p>
          </div>
        </div>

      </div>



    </div>

  </section>

  <!-- PROBLEMS SOLVED SECTION -->
  <section>
    <div class="container mx-auto my-10 md:my:20  px-10 md:px-20">
      <div class="md:grid lg:grid-cols-2 gap-20 ">
        <div class="md:-mt-40">
          <img class="shadow-2xl rounded-3xl hidden lg:block" src="@/assets/images/problem_img.jpg" alt="">
        </div>

        <div>
          <h2 class="text-2xl md:text-4xl text-center md:text-start font-semibold  text-[#05224b] leading-snug mb-5">
            Problems We Are Solving</h2>

          <p class="mb-10 text-justify  text-[#05224b]">Educational institutions are faced with numerous challenges like lengthy manual
            processes, lack of transparency, accountability, efficiency and communication. Solving these problems are
            generally expensive and time-consuming.
            We provide these institutions with affordable and efficient solutions to these
            problems. We want to bring about societal progress through Educational Technology.</p>


          <div class="md:flex lg:space-x-20 md:space-x-40">

            <ul class="flex flex-col space-y-3 mb-3">
              <li class="rounded-xl p-2 bg-[#274C79] text-white text-center font-semi-bold">Affordability</li>
              <li class="rounded-xl p-2 bg-[#274C79] text-white text-center font-semi-bold">Accessibility</li>
              <li class="rounded-xl p-2 bg-[#274C79] text-white text-center font-semi-bold">Information Safety</li>
              <li class="rounded-xl p-2 bg-[#274C79] text-white text-center font-semi-bold">Fee Collection</li>
            </ul>


            <ul class=" flex flex-col space-y-3">
              <li class="rounded-xl p-2 bg-[#274C79] text-white text-center font-semi-bold">Efficiency</li>
              <li class="rounded-xl p-2 bg-[#274C79] text-white text-center font-semi-bold">Communication</li>
              <li class="rounded-xl p-2 bg-[#274C79] text-white text-center font-semi-bold">Transparency</li>
            </ul>


          </div>
          <div class="flex lg:space-x-10 md:space-x-40 space-x-5 my-10">
            <p class="text-center font-bold text-[#070852] "><span
                class="md:text-2xl">5+</span><br>Countries</p>
            <p class="text-center font-bold text-[#E03168] "><span class="font-bold md:text-2xl">500+
              </span><br>Schools</p>
            <p class="text-center font-bold text-green-900 "><span
                class=" md:text-2xl">50+ </span><br>Organisation</p>
          </div>
        </div>
      </div>

    </div>
  </section>

  <!-- value preposition -->

  <section class="bg-[#274C79]">
    <div class="container mx-auto md:my-20 px-10 md:px-20 py-10 md:py-20 pb-10">
          <h1 class="text-center  text-2xl md:text-3xl font-semibold text-white"> There is a Solution
            for
            All Stakeholders
          </h1>
          <p class="text-center mt-3 mb-20 text-md md:text-xl  text-white">FlexiSAF Solutions are made for all
            stakeholders of Education in Nigeria. Software Tools Listings</p>

          <div class="grid grid-row lg:grid-cols-3 gap-10 text-center ">
            <div class="solution2 rounded py-5 px-7 shadow-2xl hover:shadow-md shadow-slate-900 text-white">
              <img class=" mx-auto w-14" src="@/assets/images/person.svg" alt="">
              <h3 class="text-xl md:text-2xl font-medium my-3"> A Personal Journey</h3>
              <p class="text-justify mb-5 after:text-md">

                Our clients are part of the FlexiSAF family. We stick with you and evolve together,
                providing solutions that accommodate your unique and changing needs.</p>
            </div>

            <div class="solution2 rounded py-5 px-7 shadow-2xl hover:shadow-md shadow-slate-900 text-white">
              <img class=" mx-auto w-14" src="@/assets/images/responsible.svg" alt="">
              <h3 class="text-xl md:text-2xl font-medium my-3">A Wealth of experience</h3>
              <p class="text-justify mb-5 after:text-md">
                With 10+ years of experience, our technical expertise has been emboldened by our resolve to help you
                conquer barriers.
              </p>
            </div>

            <div class="solution2 rounded py-5 px-7 shadow-2xl hover:shadow-md shadow-slate-900 text-white">
              <img class=" mx-auto w-14" src="@/assets/images/support.svg" alt="">
              <h3 class="text-xl md:text-2xl font-medium my-3 ">Dedicated support</h3>
              <p class="text-justify mb-5 after:text-md">
                We provide a wide range of support for all our customers using all our solutions to ensure that you can
                get the best experience
                and results.
              </p>
            </div>



          </div>


    </div>
  </section>

  <!-- TESTIMONIES -->

  <section >
    <div class="container mx-auto md:my-20 px-10 md:px-20 py-10 pb-20  text-[#05224b]">  
          <h1 class="text-center  text-2xl md:text-4xl font-semibold"> But Don’t Just Take Our Word For It…
          </h1>
          <p class="text-center text-md mt-3 mb-20 ">Here’s a few words from some of our clients Software Tools Listings</p>

          <div class="grid grid-row lg:grid-cols-3 gap-10 ">
            <!-- TESTIMONY 1 -->

            <div class="testimony relative rounded py-5 px-7 shadow-2xl bg-white">
              <!-- section divider -->
              <div class="custom-shape-divider-bottom-1659738852">
                <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120"
                  preserveAspectRatio="none">
                  <path
                    d="M985.66,92.83C906.67,72,823.78,31,743.84,14.19c-82.26-17.34-168.06-16.33-250.45.39-57.84,11.73-114,31.07-172,41.86A600.21,600.21,0,0,1,0,27.35V120H1200V95.8C1132.19,118.92,1055.71,111.31,985.66,92.83Z"
                    class="shape-fill"></path>
                </svg>
              </div>

              <!-- quotation icon -->
              <div class="text-[#070852] mb-5"> <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40"
                  fill="currentColor" class="bi bi-quote" viewBox="0 0 16 16">
                  <path
                    d="M12 12a1 1 0 0 0 1-1V8.558a1 1 0 0 0-1-1h-1.388c0-.351.021-.703.062-1.054.062-.372.166-.703.31-.992.145-.29.331-.517.559-.683.227-.186.516-.279.868-.279V3c-.579 0-1.085.124-1.52.372a3.322 3.322 0 0 0-1.085.992 4.92 4.92 0 0 0-.62 1.458A7.712 7.712 0 0 0 9 7.558V11a1 1 0 0 0 1 1h2Zm-6 0a1 1 0 0 0 1-1V8.558a1 1 0 0 0-1-1H4.612c0-.351.021-.703.062-1.054.062-.372.166-.703.31-.992.145-.29.331-.517.559-.683.227-.186.516-.279.868-.279V3c-.579 0-1.085.124-1.52.372a3.322 3.322 0 0 0-1.085.992 4.92 4.92 0 0 0-.62 1.458A7.712 7.712 0 0 0 3 7.558V11a1 1 0 0 0 1 1h2Z" />
                </svg></div>
              <p class="text-justify mb-24 text-sm leading-7">
                Having used "a portal" for several years before
                embracing SRMS, MAUTECH now understands the power of a system that can leverage on registration
                information to provide a complete cycle for records processing and reports generation. Information about
                students' current academic status, level,
                etc makes it possible to provide a "full controlled registration"

              </p>

              <p class="flex justify-center mx-auto w-14 h-14 text-white"><img src="@/assets/images/modibo.png" alt="">
              </p>

              <p class="font-semibold text-center text-white">Modibbo Adama University</p>
              <p class="text-center text-white">Yola</p>
            </div>

               <!-- TESTIMONY 2 -->
             <div class="testimony relative rounded py-5 px-7 shadow-2xl bg-white">
              <!-- section divider -->
              <div class="custom-shape-divider-bottom-1659738852 testimony2">
                <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120"
                  preserveAspectRatio="none">
                  <path
                    d="M985.66,92.83C906.67,72,823.78,31,743.84,14.19c-82.26-17.34-168.06-16.33-250.45.39-57.84,11.73-114,31.07-172,41.86A600.21,600.21,0,0,1,0,27.35V120H1200V95.8C1132.19,118.92,1055.71,111.31,985.66,92.83Z"
                    class="shape-fill"></path>
                </svg>
              </div>

              <!-- quotation icon -->
              <div class="text-[#E03168] mb-5"> <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40"
                  fill="currentColor" class="bi bi-quote" viewBox="0 0 16 16">
                  <path
                    d="M12 12a1 1 0 0 0 1-1V8.558a1 1 0 0 0-1-1h-1.388c0-.351.021-.703.062-1.054.062-.372.166-.703.31-.992.145-.29.331-.517.559-.683.227-.186.516-.279.868-.279V3c-.579 0-1.085.124-1.52.372a3.322 3.322 0 0 0-1.085.992 4.92 4.92 0 0 0-.62 1.458A7.712 7.712 0 0 0 9 7.558V11a1 1 0 0 0 1 1h2Zm-6 0a1 1 0 0 0 1-1V8.558a1 1 0 0 0-1-1H4.612c0-.351.021-.703.062-1.054.062-.372.166-.703.31-.992.145-.29.331-.517.559-.683.227-.186.516-.279.868-.279V3c-.579 0-1.085.124-1.52.372a3.322 3.322 0 0 0-1.085.992 4.92 4.92 0 0 0-.62 1.458A7.712 7.712 0 0 0 3 7.558V11a1 1 0 0 0 1 1h2Z" />
                </svg></div>
              <p class="text-justify mb-28 text-sm leading-7">
                As one of the early clients of FlexiSAF, Centre for Distance Learning University Of Maiduguri, never looked back since 2007 when they computerized their students' records management. With over 12,000 students' records and more than 500,000 enrolled courses, CDL can now process transcripts of its graduates and students within 24 hours.

              </p>

              <p class="flex justify-center mx-auto  w-14 h-14 text-white" ><img src="@/assets/images/modibo.png" alt=""></p>
              
              <p class="font-semibold text-center text-white">Centre for Distance Learning</p>
               <p class="text-center text-white">Maiduguri</p>
            </div>

                <!-- TESTIMONY 3 -->
          <div class="testimony  relative rounded py-5 px-7 shadow-2xl bg-white">
              <!-- section divider -->
              <div class="custom-shape-divider-bottom-1659738852 testimony3">
                <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120"
                  preserveAspectRatio="none">
                  <path
                    d="M985.66,92.83C906.67,72,823.78,31,743.84,14.19c-82.26-17.34-168.06-16.33-250.45.39-57.84,11.73-114,31.07-172,41.86A600.21,600.21,0,0,1,0,27.35V120H1200V95.8C1132.19,118.92,1055.71,111.31,985.66,92.83Z"
                    class="shape-fill"/>
                </svg>
              </div>

              <!-- quotation icon -->
              <div class="text-[#2CA2B0] mb-5"> <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40"
                  fill="currentColor" class="bi bi-quote" viewBox="0 0 16 16">
                  <path
                    d="M12 12a1 1 0 0 0 1-1V8.558a1 1 0 0 0-1-1h-1.388c0-.351.021-.703.062-1.054.062-.372.166-.703.31-.992.145-.29.331-.517.559-.683.227-.186.516-.279.868-.279V3c-.579 0-1.085.124-1.52.372a3.322 3.322 0 0 0-1.085.992 4.92 4.92 0 0 0-.62 1.458A7.712 7.712 0 0 0 9 7.558V11a1 1 0 0 0 1 1h2Zm-6 0a1 1 0 0 0 1-1V8.558a1 1 0 0 0-1-1H4.612c0-.351.021-.703.062-1.054.062-.372.166-.703.31-.992.145-.29.331-.517.559-.683.227-.186.516-.279.868-.279V3c-.579 0-1.085.124-1.52.372a3.322 3.322 0 0 0-1.085.992 4.92 4.92 0 0 0-.62 1.458A7.712 7.712 0 0 0 3 7.558V11a1 1 0 0 0 1 1h2Z" />
                </svg></div>
              <p class="text-justify mb-36 text-sm leading-7">
                Offering over 100 programs with different affiliations and grading systems, Adamawa State Polytechnic is able to manage about 10,000 students' records in every session and produce 
              their results in time and ensure high integrity of records. 
              Delivering in time and the level of accuracy was a big challenge before the intervention.
              </p>

              <p class="flex justify-center mx-auto  w-14 h-14 text-white" ><img src="@/assets/images/adama-Uni.jpeg" alt="Adama state uni logo"></p>
              
              <p class="font-semibold text-center text-white">Adamawa State Polytechnic</p>
               <p class="text-center text-white">Yola</p>
            </div>



          </div>
    </div>
  </section>
 <!-- GIVING -->
  <section class="bg-giving bg-cover ">
    <div class="container mx-auto md:my-20 px-10 md:px-20 py-10 pb-20">
      <div class="md:grid lg:grid-cols-2 gap-10">
        <div class="">
          <h1 class="text-white text-3xl font-bold mb-5">How we give back</h1>
          <p class="text-white my-5 ">FlexiSAF believes that by being part and parcel of the society, it must contribute positively in the overall well-being of our community.  
            As such we strive to attack the ills of society using what we do best.</p>

            <div class="flex flex-col md:flex-row md:space-x-10">
           
                <a class="py-3 px-5 rounded bg-slate-200 border-2 border-cyan-700 shadow mb-5" href="">
                  
                  <img class="mx-auto mb-5 w-32 " src="@/assets/images/fs-foundation.svg" alt="">
                  <p class="text-sm text-justify mb-3"> There are millions of children across the globe who would love to learn
                  but do not get the chance. Find out our response (intervention?) to this.</p>
                 </a>

                <a class="py-3 px-5 rounded bg-slate-200 border-2 border-cyan-700 shadow mb-5" href="">
                   <img class="mx-auto mb-5 w-40 " src="@/assets/images/kids-coders.svg" alt="">
                   <p  class="text-sm text-justify mb-3"> There are millions of children across the globe who would love to learn
                  but do not get the chance. Find out our response (intervention?) to this.</p>
                 </a>
              </div>

        </div>

        <div class="hidden lg:block relative ">
        <div class="bg-black">
          <img class="giving give1 absolute top-4 left-24 w-48" src="@/assets/images/give-1.png" alt="">
        <img class="giving give2 absolute -bottom-3 left-24 w-48" src="@/assets/images/give-2.png" alt="">
        <img class="giving give3 absolute -bottom-2 left-72 -right-5 w-48 " src="@/assets/images/give-3.png" alt="">
        </div>

        </div>

      </div>

    </div>
  </section>

 <!-- CONTACT -->
  <section class="container mx-auto md:my-40">
    <div class="my-10 lg:mx-60 md:mx-20 mx-5">
      <div class="bg-contact py-14 px-5 text-center rounded-xl">
        <h1 class="text-3xl font-bold text-white mb-5 underline">Get in touch with us</h1>
        <p class="text-white mb-5">Have questions, or want to talk about working with us?</p>
        <button
              class="bg-cyan-600 text-white text-md spec-btn  px-5 py-2  font-bold  duration-500  hover:bg-[#10116B]">
             Contact us</button>

      </div>

    </div>

  </section>

  <!-- FOOTER -->

  <footer class="bg-[#05224B] py-10 ">
    <div class="container mx-auto px-10 md:px-20 ">
      <div class="lg:grid lg:grid-cols-12  gap-10">
        <div class="col-span-4 text-white mb-10">
          <img class="w-32 mb-5" src="@/assets/images/green-horizontal.svg" alt="">
          <small class="opacity-50"> Flexisaf Edusoft Limited Nigeria</small><br><br>
          <small class="opacity-50">No. 3 Egbedi Close, off Samuel Ladoke Akintola Boulevard, Garki 2, Abuja, Nigeria.</small><br><br>
          <small class="opacity-50">Give us a call +234 705 988 7123</small>
        </div>
            <div class="col-span-1 mb-20"></div>
         
         <div class="col-span-7">
            <ul class="md:flex justify-center md:space-x-10  text-white opacity-90 ">
            <li>
              <p class="font-bold text-xl mb-5">Company</p>
              <p class="mb-5 text-sm">About Us</p>
              <p class="mb-5 text-sm">Contact Us</p>
              <p class="mb-5 text-sm">Careers</p>
            </li>

             <li>
              <p class="font-bold text-xl mb-5">Products</p>
              <p class="mb-5 text-sm">SAFSMS</p>
              <p class="mb-5 text-sm">SAFAPPLY</p>
              <p class="mb-5 text-sm">SRMS</p>
            </li>

           <li>
              <p class="font-bold text-xl mb-5">Resources</p>
              <p class="mb-5 text-sm">Contact</p>
              
            </li>

            <li>
              <p class="font-bold text-xl mb-5"> Legal</p>
              <p class="mb-5 text-sm">Privacy</p>
              <p class="text-sm mb-5">Terms of Service</p>
              
              
            </li>

          </ul>
         </div>
         
        
      

      </div>

      <div class="mt-10 opacity-60">
        <hr>
        <div class="md:flex justify-between text-white my-5">
          <p class="mb-5">© 2022 Flexisaf. All rights reserved | Sitemap</p>

          <ul class="flex space-x-5">
           <a href=""> <img src="@/assets/images/facebook.svg" alt=""></a>
        
           <a href=""><img src="@/assets/images/twitter.svg" alt=""></a>
            <a href=""><img src="@/assets/images/linkedin.svg" alt=""></a>
             <a href=""><img src="@/assets/images/instagram.svg" alt=""> </a>
            
             
          </ul>

        </div>
      </div>

    </div>


  </footer>

</template>

<script>
import NavBar from '@/components/NavBar.vue'

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

export default {
  name: 'HomeView',
  components: {
    NavBar
  },

  mounted: function () {
    this.scrollAnimation();

  },
  methods: {
    scrollAnimation() {

      gsap.from('.showcase', {

        y: 200,
      })
      gsap.to('.showcase', {
        y: 0,
        duration: 3,
      });


      gsap.from('.slidimg', {
        x: -300,
        opacity:0


      })
      gsap.to('.slidimg', {
        x: 0,
        duration: 3,
        scrollTrigger: {
          trigger: ".slidimg",
          toggleActions: 'restart none restart none',
          // markers:true
        }
      });

      gsap.from('.product1', {
        opacity: 0,
        scale: 0.5,
        ease: 'back',
        duration: 1.5,
        scrollTrigger: {
          trigger: ".product1",
          toggleActions: 'restart none restart none',
        }

      });

      gsap.from('.product2', {
        opacity: 0,
        duration: 1.5,
        stagger: 0.5,
        delay: 1,
        scrollTrigger: {
          trigger: ".product2",
          toggleActions: 'restart none play none',
        }

      });

      gsap.from('.solution1', {
        opacity: 0,
        y: 'random(100,300)',
        duration: 1.5,
        stagger: 0.25,
        delay: 0.5,
        scrollTrigger: {
          trigger: ".solution1",
          toggleActions: 'restart none play none',
        }

      });

      gsap.from('.solution2', {
        opacity: 0,
         x: 'random(100,300)',
        duration: 1.5,
        stagger: 0.25,
         delay: 0.5,
        scrollTrigger: {
          trigger: ".solution2",
          toggleActions: 'restart none play none',
        }

      });

         gsap.from('.testimony', {
        opacity: 0,
         y: 'random(100,300)',
        duration: 1.5,
        stagger: 0.25,
         delay: 0.5,
        scrollTrigger: {
          trigger: ".testimony",
          toggleActions: 'restart none play none',
        }

      });


         gsap.from('.giving', {
          opacity:0,
         y: 'random(100,200)',
           x: 'random(100,200)',
        duration: 1.5,
        stagger: 0.8,
        delay: 0.5,
        scrollTrigger: {
          trigger: ".giving",
          toggleActions: 'restart none none none',
        }

      });

    },


  }
}
</script>

<style scoped>

.slidimg,.solution1,.solution2{
  overflow: hidden !important;
}
.cover-img {
  opacity: 0.9
}

.custom-shape-divider-bottom-1659189854 {
  position: absolute;
  bottom: -3px;
  left: 0;
  width: 100%;
  overflow: hidden;
  line-height: 20px;

}

.custom-shape-divider-bottom-1659189854 svg {
  position: relative;
  display: block;
  width: calc(100% + 1.3px);
  height: 100px;
  transform: rotateY(180deg);
}

.custom-shape-divider-bottom-1659189854 .shape-fill {
  fill: #FFFFFF;
}


.custom-shape-divider-bottom-1659738852 {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  overflow: hidden;
  line-height: 0;
  z-index: -1;
}

.custom-shape-divider-bottom-1659738852 svg {
  position: relative;
  display: block;
  width: calc(243% + 1.3px);
  height: 200px;

}

.custom-shape-divider-bottom-1659738852 .shape-fill {
  fill: #070852;
}

.testimony2 .shape-fill {
  fill:#E03168;
}

.testimony3 .shape-fill {
  fill:#2CA2B0
}



</style>
